import { Lock, Unlock } from 'lucide-react';
import React from 'react';
import { ActionButton } from './ActionButton';

interface LockActionsProps {
  isLockedByCurrentUser: boolean;
  isLockedByOtherUser: boolean;
  disabled?: boolean;
  onLock: () => void;
  onUnlock: () => void;
  actionLoading:
    | 'retry'
    | 'delete'
    | 'save'
    | 'lock'
    | 'unlock'
    | 'restore'
    | 'zurueckstellen'
    | null;
}

export const LockActions: React.FC<LockActionsProps> = ({
  isLockedByCurrentUser,
  isLockedByOtherUser,
  disabled = false,
  onLock,
  onUnlock,
  actionLoading,
}) => {
  if (isLockedByCurrentUser) {
    return (
      <ActionButton
        onClick={onUnlock}
        disabled={disabled || actionLoading !== null}
        loading={actionLoading === 'unlock'}
        loadingText="Wird entsperrt..."
        normalText="Entsperren"
        icon={Unlock}
        variant="outline"
      />
    );
  }

  if (!isLockedByCurrentUser && !isLockedByOtherUser) {
    return (
      <ActionButton
        onClick={onLock}
        disabled={disabled || actionLoading !== null}
        loading={actionLoading === 'lock'}
        loadingText="Wird gesperrt..."
        normalText="Sperren & Bearbeiten"
        icon={Lock}
        variant="outline"
      />
    );
  }

  return null;
};
